export const getFirstWordUpperCase = (str: string): string =>
  str[0]?.toUpperCase() + str.slice(1)?.toLowerCase();
